import React from "react";
import api from "../../utils/api";
import utils from "../../utils";
import { Steps } from "antd";
import { OneStepBlackIcon, TwoStepBlackIcon, ThreeStepBlackIcon, TwoStepGrayIcon, ThreeStepGrayIcon, StepSplit, StepGraySplit,Step1, Step2, Step3 } from "Common/ReactIcons";
import "./Appointment.scss";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { historyState } from "../../store/slice/history-slice";
import Loader from "Components/Loader";
import SelectReason from "./SelectReason";
import SelectSlots from "./SelectSlots";
import AppointmentConfirmation from "./AppointmentConfirmation";
import AppointmentInfoCard from "./AppointmentInfoCard";
import { CONSTANTS } from "utils/constant";
import SelectedClinicianCard from "./SelectedClinicianCard";
import { withTranslation , Trans} from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import { setActivePlan } from "store/slice/login-slice";
import SelectActivePlan, { InfoCardEdit } from "./SelectActivePlan";
import Icons from "Common/Icons";


const Step=Steps.Step;
class ScheduleAppointment extends React.Component {
  _baseClassName = "schedule-appointment-container";
  constructor(props) {
    super(props);
    this.state = {
      user_details: this.props.user_details,
      slotData: [],
      slot_details: [],
      flag: false,
      active_step:1,
      reason_status:"process",
      slot_status:"wait",
      app_status:"wait",
      patient_status:this.byPassActivePlan(), //hold entire patient-status APi Data
      doctorID : this.props?.doctorID || "",
      doctorSelectedData : this.props?.doctorSelectedData || {},
      isLoading:false,
      appointmentData:{},
      appointmentStepper : props?.appointmentStepper || false,
      slots_loader:true,
    };
  }
  byPassActivePlan(){
    let data=this.props?.data;
    let activeCarePlan=this.props?.activeCarePlan||null;   
    if(this.props?.doctorID && activeCarePlan){
      // const activePlan = findActivePlan(data.care_plans);
      return {...data,care_plan:activeCarePlan};
    }
    else{
      const activePlan = utils.getLatestPlan(data.care_plans);
      return {...data,care_plan:activePlan};
    }
  }
  handleBookAppointment=(datetime) =>{
      api
      .schedule_appointment_available_doctors(datetime)
      .then((response
        
        ) => {
        if (response.data?.status == 200) {
          this.setState({ slot_details: response.data?.data,isLoading:false, slot_status:"finished" });
         
        }else{
          this.setState({ isLoading: false })
        }
      })
      .then((res) => {
        if (res.data?.status == 200) {
          this.setState({ isLoading: false })
          let subscription = localStorage.getItem("subscription") === null ? {} : JSON.parse(localStorage.getItem("subscription"));
          let output = { ...subscription, ...res.data?.data }
          localStorage.setItem("subscription", JSON.stringify(output));
          this.props.history.push({
            pathname: `/logged-in-user/consultation-history`,
            selected_date: "09/07/2022",
          })
        } else if (res.data?.status == 400) {
          this.setState({ isLoading: false })
          // utils.Toast({ type: "warning", message: res.data?.message });
          this.setState({ selectedSlot: null });
        }
      })
      .catch((err) => { });
    
  }
  componentDidMount() {
    this.setState({
      selectedDate: utils.FormatDate(this.props.currentOffsetDateTime), isLoading:false, 
    });
  }
 
  navigateBackPage(){
     this.props.history.goBack();
  }

  submitAreaOfImprovement(data){
    api.update_area_improvements(data).then(res => {
      if(res?.status == 200)
      {
          this.setState({active_step:2});
      }
      else
      {
        
      }
    }).finally(() => {
    })
  }
  handleReasonStatus=(options)=>{
    this.submitAreaOfImprovement(options);    
  }
  appointmentBookedUpdateStep(step,appointmentData){
    this.setState({active_step:step, appointmentData});
  }
  appointmentUpdated(){
    typeof this.props?.getAppointmentView == "function" && this.props?.getAppointmentView(); // rescheduled or cancelled
  }
  redirectTo(redirectValue,historyPush){
    if(historyPush) {this.props.history.push({ pathname: `/logged-in-user/${redirectValue}`}); return;}
    if(redirectValue == "appointmentStepper") this.setState({appointmentStepper : true});
  }
  handleSlotsLoader=(flag)=>{
this.setState({slots_loader:flag})
  }
  handleSelectActivePlan(){        
    utils.Modal(true, { content: <SelectActivePlan onClick={(payload)=>{
      utils.Modal(false);
      this.props.setActivePlan(payload)
    }} care_plan_arr={this.props?.data.care_plans} activeCarePlan={this.props.activeCarePlan} doctorID={this.props.doctorID}/>, width: "480px" })            
  }
      renderStepper = () => {
  switch (this.state.active_step) {
    case 1:
      return <Step1 />;
    case 2:
      return <Step2 />;
    case 3:
      return <Step3 />;
    default:
      return <Step1 />;
  }
};
  render() {
    // let steppers= [
    //   { id: 1, label: "", icon: <Step1/> },
    //   { id: 2, label: "", icon: <Step2/> },
    //   { id: 3, label: "", icon: <Step3/> }
    // ];


    const { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    let activeCarePlan=this.props?.activeCarePlan||null; 
    return (
      <div>
        {this.state.isLoading ? <Loader tgtLangST={tgtLangST}/> :
        <>
        {
          !this.state.appointmentStepper ? <AppointmentInfoCard patient_status={this.state.patient_status} redirectTo={this.redirectTo.bind(this)} includePrimeLang={this.props.includePrimeLang}/>
        : <div   className="sched-app-wrapper">
          <div className="steps-wrapper schedule-app-stepper" id="steps-wrapper">
              <div style={{display:"flex"}}>
              <div style={{ display: "flex", alignItems: "center" }}>
  <div className="stepper-container">
  {this.renderStepper()}
</div>

</div>

              </div>
        </div>
        <div className="app-stepper-title"><Trans components={TS_STYLD_COMPS}>{t((this.state.active_step==1 ? CONSTANTS.SELECT_REASON : this.state.active_step==2 ? CONSTANTS.SELECT_DATE_AND_TIME : CONSTANTS.APPOINTMENT_BOOKED),{lng:tgtLangST})}</Trans></div>
        {/* redux doctor selected && step 1 or step 2  --> Show doctor selected Card */}
        {this.state.doctorID && this.state.active_step!=3 && <SelectedClinicianCard slots_loader={this.state.slots_loader} doctorSelectedData={this.state.doctorSelectedData} redirectTo={this.redirectTo.bind(this)}/>}
        {this.state.doctorID && this.state.active_step!=3 && activeCarePlan &&!this.state.slots_loader && <div className="slct-res-words-new" style={{marginBottom:"24px"}}>
              <div className="slct-res-words-title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SELECTED_PLAN,{lng:tgtLangST})}</Trans></div>
              <div>
                <InfoCardEdit  title={activeCarePlan.plan_name}
        description={utils.sessionsCompletedText(activeCarePlan?.completed_sessions, activeCarePlan?.total_sessions)} Icon={Icons.plan_icon} onClick={()=>this.handleSelectActivePlan()} hide_edit={activeCarePlan?.hide_edit}/>
              </div>
            </div>}
        {this.state.active_step==1?
           <div >
              {
               <div className="select-reason-with-img"><SelectReason  updateReason={this.handleReasonStatus} includePrimeLang={this.props.includePrimeLang} setActivePlan={this.props.setActivePlan} care_plan_arr={this.props?.data.care_plans} activeCarePlan={this.props?.activeCarePlan} doctorSelectedData={this.state.doctorSelectedData} doctorID={this.state.doctorID || ""}/></div>}
                </div>
                :this.state.active_step==2? 
                <div className="select-slots-with-img">
                  <SelectSlots handleBookAppointment={this.handleBookAppointment} user_details={this.state.user_details}
                  doctorID={this.state.doctorID || ""} handleSlotsLoader={this.handleSlotsLoader} doctorSelectedData={this.state.doctorSelectedData} currentOffsetDateTime={this.props.currentOffsetDateTime} appointmentBookedUpdateStep={this.appointmentBookedUpdateStep.bind(this)} patient_status={this.state.patient_status} includePrimeLang={this.props.includePrimeLang}/>
                  </div>:
                  <div>
                 <AppointmentConfirmation appointmentData={this.state.appointmentData} appointmentUpdated={this.appointmentUpdated.bind(this)}/>
                    </div>}
                  </div>
        }</>
                       }
                     </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user_details: state.loginReducer.user_details,
    includePrimeLang: state.loginReducer.includePrimeLang,
    activeCarePlan:state.loginReducer.activeCarePlan,
  }
}
const mapDispatchToProps = {
  historyState,
  setActivePlan
}
export default  compose(withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ScheduleAppointment))));